module.exports = __webpack_public_path__ + "img/exam_2.ec3cc00f.png";